import {
  useCallback, useContext, useEffect, useMemo, useRef, useState,
} from 'react';
import { RELOAD_TIMEOUT } from '../../../const/misc';
// eslint-disable-next-line import/no-cycle
import useListerBackend from './backend';
// eslint-disable-next-line import/no-cycle
import useListerActions from './actions';
// import { WinManagerContext } from '../../../providers/winManagerProvider';
import { useDebounce } from '../../../utils/debounce';
import WinManagerContext from '../../../providers/winManagerProvider';
// import { periodVarians } from '../../../constants/date';

/**
 *
 * @param backendURL {string} - тип
 * @param viewType {string} - lister / selector
 * @param options {{
 *    initialValue: {
 *        id: string,
 *        repr: string,
 *    },
 *    initialFilter: {},
 *    noHierarchy: boolean,
 * }}
 * @returns {{
 * visibleColumns: {}[] Видимые колонки с опиcаниями из метаданных,
 * items: {}[] Собственно данные,
 * activeRow: string id текущей строки,
 * selectedRows: string[] массив ид выделенных строк не пуать с текущей строкой,
 * order: {
 *   column: string,
 *   isAscending: boolean,
 * },
 * loading: bool,
 * err: string,
 * onRowClick: function стандартная реакиця на клик по строке,
 * onReload: function,
 * onNextPage: function,
 * showDeleted: boolean,
 * searchString: string,
 * filterOpened: boolean,
 * period: {
 *   startDate: number,
 *   endDate: number,
 *   variant: string,
 * },
 * approveStatus: {mode: number, status: {}, history: {}},
 * messages: { title: string, text: string, variant: string }[],
 * filteringFields: {name: string, label: string, type: string}[],
 * permissions: {
 *  canNew: boolean,
 *  canEdit: boolean,
 *  canCopy: boolean,
 *  canDelete: boolean,
 *  canShowDeleted: boolean,
 *  canSearch: boolean,
 *  canNextPage: boolean,
 * },
 * actions: {
 *  onNew: function,
 *  onEdit: function,
 *  onCopy: function,
 *  onDelete: function,
 *  onNewGroup: function,
 *  onToggleShowDeleted: function,
 *  onExecute: function,
 *  onUnexecute: function,
 *  onSearch: function,
 *  onSetPeriod: function,
 *  onSetFilter: function,
 *  onClearMessages: function,
 *  onDeleteMessage: function,
 * },
 * meta: {
 *   label: string,
 *   description: string,
 * }
 * }}
 */
const useLister = (
  backendURL,
  viewType,
  options,
) => {
  const { listersTimeStamps, setWindowTitle } = useContext(WinManagerContext);
  // const listersTimeStamps = {};
  const periodVarians = useMemo(() => [], []);

  const timestamp = listersTimeStamps[backendURL] || -1;

  const opt = useMemo(
    () => {
      const defaults = {
      // Начальное значение
        initialValue: null,
        // Принудительное отключение иерархии
        noHierarchy: false,
        // первоначальная сортировка {column, direction}
        initialOrder: { column: '', isAscending: true },
        initialFilter: {},
        onSelect: null,
        onChoice: null,
        overridePermissions: {},
        params: [],
      };
      return { ...defaults, ...options };
    },
    [options],
  );

  const [search, setSearch] = useState('');

  const [backendSearch, setBackendSearch] = useState(search); // поиск, который используется для

  const [orderColumn, setOrderColumn] = useState({
    column: opt.initialOrder.column,
    isAscending: opt.initialOrder.isAscending,
  });

  const [filterOpened, setFilterOpened] = useState(false);
  // key: filter, где key - ключ ( для разделения в компонентах);
  const [localFilter, setLocalFilter] = useState({});

  const [showDeleted, setShowDeleted] = useState(false);

  const [selectedRows, setSelectedRows] = useState(opt.initialValue ? [opt.initialValue.get('id')] : []);

  const refedSelectedRows = useRef(selectedRows);

  useEffect(
    () => {
      refedSelectedRows.current = selectedRows;
    },
    [selectedRows],
  );

  const onSetOrder = useCallback(
    (e, column) => setOrderColumn((o) => {
      if (column === o.column) {
        return {
          column,
          isAscending: !o.isAscending,
        };
      }
      return {
        column,
        isAscending: true,
      };
    }),
    [],
  );

  // EndDate: 1600905599584
  // StartDate: 1600819200584
  // Variant: "Custom"
  const [period, setPeriod] = useState({
    start: null,
    end: null,
    variant: null,
  });

  const [periodLoaded, setPeriodLoaded] = useState(false);
  const [pathLoaded, setPathLoaded] = useState(false);

  const [usedFilter, setUsedFilter] = useState(null);
  const defaults = useMemo(
    () => ({}),
    //   opt.initialFilter
    // .filter(({ comparisonType }) => !comparisonType || comparisonType === comparisonTypes.equal)
    // .reduce((R, { fieldName, value }) => ({ ...R, [fieldName]: value }), {}),
    [],
  );

  const {
    visibleColumns, items, loading, err, onReload, onLoadOptions, onNextPage,
    permissions: backPermissions,
    onDeleteItems, onExecute: onExecuteItems, onUnexecute: onUnexecuteItems,
    onLoadSettings, onSaveSettings, settings, onSetSettings, settingsLoaded,
    onLoadChildren, onUnloadChildren, loadPath,
    messages, clearMessages, deleteMessage,
    pageInfo, optionsLoaded, filteringFields, onExportXLS,
    meta,
  } = useListerBackend({
    backendURL,
    viewType,
    filter: usedFilter,
    order: orderColumn,
    searchString: backendSearch,
    noHierarchy: opt.noHierarchy,
    params: opt.params,
    defaults,

  });

  const readyToLoad = periodLoaded && pathLoaded && optionsLoaded && settingsLoaded;

  const periodFilter = useMemo(
    () => {
      const { start, end } = period.variant in periodVarians
        ? periodVarians[period.variant].eval() : period;
      return {
        ...(start ? { date__gte: start } : {}),
        ...(end ? { date__lte: end } : {}),
      };
    },
    [period, periodVarians],
  );

  useEffect(
    () => {
      if (readyToLoad) {
        setUsedFilter({
          ...opt.initialFilter,
          ...(showDeleted || !backPermissions.canHideDeleted ? {} : { deleted: false }),
          ...(Object.keys(localFilter)
            .filter((lf) => localFilter[lf].use)
            .reduce((R, lf) => ({
              ...R,
              [lf]: typeof localFilter[lf].value === 'object' && localFilter[lf].value !== null ? localFilter[lf].value.id : localFilter[lf].value,
            }), {})
          ),
          ...periodFilter,
        });
      }
    },
    [backPermissions, localFilter, opt.initialFilter, optionsLoaded, periodFilter, readyToLoad, showDeleted],
  );

  const [openedItems, setOpenedItems] = useState([]);
  useEffect(
    () => {
      onLoadOptions();
    },
    [onLoadOptions],
  );
  useEffect(
    () => {
      if (!pathLoaded && opt.initialValue && opt.initialValue.id) {
        loadPath(
          opt.initialValue.id,
          opt.initialValue.repr,
          (path) => {
            pageInfo.current.parents = [...pageInfo.current.parents, ...path];
            setOpenedItems(path);
            setPathLoaded(true);
          },
        );
      } else {
        setPathLoaded(true);
      }
    },
    [loadPath, opt, opt.initialValue, pageInfo, pageInfo.parents, pathLoaded],
  );

  const onRowFocus = useCallback(
    (e, rowId, multiple = false) => {
      // setActiveRow(rowId);
      setSelectedRows((oldV) => {
        if (multiple && oldV.includes(rowId)) return oldV.filter((o) => o !== rowId);
        if (multiple && !oldV.includes(rowId)) return [...oldV, rowId];
        return [rowId];
      });
      if (opt.onSelect) {
        const selectedItem = items
          .filter((item) => item.id === rowId)
          .reduce((R, row) => row, null);
        opt.onSelect(e, selectedItem);
      }
    },
    [items, opt],
  );

  const displayItems = useMemo(
    () => {
      if (backendSearch || !backPermissions.canHierarchy) return items;
      const getChildren = (parent = null, level = 0) => items
        .filter((item) => (typeof item.parent === 'object' && item.parent ? item.parent.id === parent : item.parent === parent))
        .reduce((R, item) => [
          ...R,
          { ...item, level },
          ...openedItems.includes(item.id) ? getChildren(item.id, level + 1) : [],
        ], []);
      return getChildren();
      //
    },
    [backPermissions.canHierarchy, backendSearch, items, openedItems],
  );

  const debouncedBackendSearch = useDebounce(setBackendSearch);

  const actions = useListerActions({
    backendURL,
    viewType,
    backPermissions,
    items,
    refedSelectedRows,
    openedItems,
    setOpenedItems,
    onExecuteItems,
    onDeleteItems,
    onUnexecuteItems,
    setShowDeleted,
    onUnloadChildren,
    onLoadChildren,
    setSearch,
    debouncedBackendSearch,
    setPeriod,
    onSetSettings,
    onChoice: opt.onChoice,
    setLocalFilter,
    onReload,
    defaults,
    clearMessages,
    deleteMessage,
    setFilterOpened,
    onExportXLS,
  });

  const permissions = useMemo(
    () => ({
      ...backPermissions,
      canNew: backPermissions.canNew,
      canNewFolder: backPermissions.canNewFolder,
      canCopy: backPermissions.canCopy && selectedRows.length > 0,
      canEdit: backPermissions.canEdit && selectedRows.length > 0,
      canDelete: backPermissions.canDelete && selectedRows.length > 0,
      canSearch: items.length > 0,
      canShowDeleted: backPermissions.canHideDeleted,
      canExecute: backPermissions.canExecute && selectedRows.length > 0,
      canUnexecute: backPermissions.canUnexecute && selectedRows.length > 0,
      canHierarchy: backPermissions.canHierarchy && !opt.noHierarchy,
      canFilter: true,
      ...opt.overridePermissions,
    }),
    [backPermissions, items.length, opt.noHierarchy, opt.overridePermissions, selectedRows.length],
  );

  useEffect(
    () => {
      if (optionsLoaded) {
        onLoadSettings();
        return () => onSaveSettings();
      }
      return null;
    },
    [onLoadSettings, onSaveSettings, optionsLoaded],
  );

  useEffect(
    () => {
      if (settingsLoaded && settings && !periodLoaded) {
        if ('period' in settings) {
          setPeriod({
            start: settings.period.start,
            end: settings.period.end,
            variant: settings.period.variant,
          });
        } else {
          setPeriod({
            start: null,
            end: null,
            variant: null, // enums.PeriodSelection.Custom.name,
          });
        }
        setPeriodLoaded(true);
      }
    },
    [periodLoaded, settings, settingsLoaded],
  );
  const reloadInterval = useRef(null);
  useEffect(
    () => {
      if (optionsLoaded && usedFilter && timestamp && pathLoaded) {
        onReload();
        reloadInterval.current = setInterval(onReload, RELOAD_TIMEOUT);
      }
      return () => {
        if (reloadInterval.current && pathLoaded) clearInterval(reloadInterval.current);
      };
    },
    [onReload, optionsLoaded, pathLoaded, timestamp, usedFilter],
  );

  useEffect(
    () => {
      if (optionsLoaded) {
        setWindowTitle(meta.frontend, meta.label);
      }
    },
    [meta, optionsLoaded, setWindowTitle],
  );

  return {
    visibleColumns,
    items: displayItems,
    openedItems,
    selectedRows,
    order: orderColumn,
    loading,
    err,
    showDeleted,
    searchString: search,
    filterOpened,
    settings,
    period,
    localFilter,

    onRowFocus,
    onSetOrder,
    onReload,
    onNextPage,
    permissions,
    onSetSettings,

    actions,
    messages,
    filteringFields,
    meta,
  };
};

export default useLister;
